<div class="d-flex flex-column gap-2 h-100">
  <div class="review-entry-label">{{ label }}</div>
  <div class="mt-auto" *ngIf="statusPill">
    <app-status-pill [statusPill]="statusPill" />
  </div>
  <hr class="m-0" />
</div>
